import styled from 'styled-components';
import {
  ButtonBase,
  PrimaryLink,
  BaseColumnWrap,
} from '../../../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

export const UpsellInclusions = styled.div(
  props => `
      flex: 1;
      display:flex;
      justify-content: center;
      flex-direction: column;
      padding:${props.theme.spacing.custom(18)};
      margin:0px 80px;
  `,
);

export const UpsellRefund_text = styled.p(
  props => `
        font-size: ${props.theme.font.custom(14)};
        font-weight: 600;
        margin-bottom: ${props.theme.spacing.large};
        `,
);

export const UpsellBulletCircle_Black = styled.span(
  props => `
      background:${props.theme.colors.downriver.base};
      width:6px;
      height:6px;
      border-radius:50%;
      margin-right:  ${props.theme.spacing.custom(13)};
      flex-shrink: 0;
      margin-top: 4px;
      display:block;
          `,
);

export const UpsellFree_Checkin = styled.span(
  props => `
       font-size: ${props.theme.font.custom(14)};
            `,
);

export const UpsellInclusionsFlexWrap = styled.span(
  props => `
       display:flex;
       margin-bottom:1rem;
            `,
);

export const RoomRefundWrap = styled.p(
  props => `
    color:${props.theme.colors.goRed.base};
    padding-bottom:${props.theme.spacing.xsmall};
    font-size:14px;
    `,
);

export const RoomFreeCancellationWrap = styled.p(
  props => `
    color:${props.theme.colors.goGreen.base};
    padding-bottom:${props.theme.spacing.xsmall};
    font-size:14px;
    `,
);

export const ViewMoreLink = styled(PrimaryLink)(
  props => `
        font-size:${props.theme.font.custom(14)};
        font-weight: 600;
        padding-top:10px;
        
    `,
);
